// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimsDeadlineEndOfCoveragePropertyDto
 */
export interface IClaimsDeadlineEndOfCoveragePropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimsDeadlineEndOfCoveragePropertyDto
     */
    claims_deadline_end_of_coverage_days_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimsDeadlineEndOfCoveragePropertyDto
     */
    claims_deadline_end_of_coverage_type?: IClaimsDeadlineEndOfCoveragePropertyDtoClaimsDeadlineEndOfCoverageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IClaimsDeadlineEndOfCoveragePropertyDto
     */
    claims_deadline_end_of_coverage_state?: IClaimsDeadlineEndOfCoveragePropertyDtoClaimsDeadlineEndOfCoverageStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IClaimsDeadlineEndOfCoveragePropertyDtoClaimsDeadlineEndOfCoverageTypeEnum {
    LAST_DAY_OF_MONTH_END_DATE = 'LAST_DAY_OF_MONTH_END_DATE',
    PLAN_YEAR_END_DATE = 'PLAN_YEAR_END_DATE',
    COVERAGE_END_DATE = 'COVERAGE_END_DATE',
    PRE_DEFINED_END_DATE = 'PRE_DEFINED_END_DATE'
}
/**
* @export
* @enum {string}
*/
export enum IClaimsDeadlineEndOfCoveragePropertyDtoClaimsDeadlineEndOfCoverageStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IClaimsDeadlineEndOfCoveragePropertyDto interface.
 */
export function instanceOfIClaimsDeadlineEndOfCoveragePropertyDto(value: object): value is IClaimsDeadlineEndOfCoveragePropertyDto {
    return true;
}

export function IClaimsDeadlineEndOfCoveragePropertyDtoFromJSON(json: any): IClaimsDeadlineEndOfCoveragePropertyDto {
    return IClaimsDeadlineEndOfCoveragePropertyDtoFromJSONTyped(json, false);
}

export function IClaimsDeadlineEndOfCoveragePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimsDeadlineEndOfCoveragePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claims_deadline_end_of_coverage_days_amount': json['claims_deadline_end_of_coverage_days_amount'] == null ? undefined : json['claims_deadline_end_of_coverage_days_amount'],
        'claims_deadline_end_of_coverage_type': json['claims_deadline_end_of_coverage_type'] == null ? undefined : json['claims_deadline_end_of_coverage_type'],
        'claims_deadline_end_of_coverage_state': json['claims_deadline_end_of_coverage_state'] == null ? undefined : json['claims_deadline_end_of_coverage_state'],
    };
}

export function IClaimsDeadlineEndOfCoveragePropertyDtoToJSON(json: any): IClaimsDeadlineEndOfCoveragePropertyDto {
    return IClaimsDeadlineEndOfCoveragePropertyDtoToJSONTyped(json, false);
}

export function IClaimsDeadlineEndOfCoveragePropertyDtoToJSONTyped(value?: IClaimsDeadlineEndOfCoveragePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claims_deadline_end_of_coverage_days_amount': value['claims_deadline_end_of_coverage_days_amount'],
        'claims_deadline_end_of_coverage_type': value['claims_deadline_end_of_coverage_type'],
        'claims_deadline_end_of_coverage_state': value['claims_deadline_end_of_coverage_state'],
    };
}

